module.exports = __webpack_public_path__ + "img/icon.85804a16.png";